import { Box, Typography } from "@mui/material";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import { palette } from "../../../theme";

// Mattoncini condivisi della home reseller: card KPI e pannello con header.
// Stessa grammatica visiva di Tiresia/Aggregations: superfici #1e1e1e/#292929,
// bordo sottile, raggio 10px, accento primary solo su hover/stato attivo.

export const MUTED = "rgba(234,234,234,0.45)";
export const SURFACE = "#1e1e1e";
export const SURFACE_HEAD = "#292929";
export const BORDER = "#292929";

export const StatCard = ({ icon: Icon, label, value, hint, onClick, chevron = true, children }) => {
  const clickable = typeof onClick === "function";
  return (
    <Box
      role={clickable ? "button" : undefined}
      tabIndex={clickable ? 0 : undefined}
      onClick={onClick}
      onKeyDown={clickable ? (e) => { if (e.key === "Enter" || e.key === " ") { e.preventDefault(); onClick(e); } } : undefined}
      sx={{
        height: "100%",
        display: "flex",
        alignItems: "center",
        gap: 2,
        p: 2,
        backgroundColor: SURFACE,
        border: `1px solid ${BORDER}`,
        borderRadius: "10px",
        cursor: clickable ? "pointer" : "default",
        transition: "border-color .15s ease, background-color .15s ease",
        "&:hover": clickable ? { borderColor: palette.primary.main, backgroundColor: "#222" } : undefined,
        "&:focus-visible": { outline: `1px solid ${palette.primary.light}`, outlineOffset: 2 },
      }}
    >
      <Box
        sx={{
          flexShrink: 0,
          width: 44,
          height: 44,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          borderRadius: "10px",
          color: palette.primary.light,
          backgroundColor: "rgba(69,144,149,0.14)",
        }}
      >
        <Icon />
      </Box>

      <Box sx={{ minWidth: 0, flex: 1 }}>
        <Typography sx={{ fontSize: 12, fontWeight: 600, letterSpacing: 0.6, textTransform: "uppercase", color: MUTED }} noWrap>
          {label}
        </Typography>
        <Typography sx={{ fontSize: 28, fontWeight: 700, lineHeight: 1.2, color: "#eaeaea" }} noWrap>
          {value}
        </Typography>
        {hint && (
          <Typography sx={{ fontSize: 12, color: MUTED }} noWrap>
            {hint}
          </Typography>
        )}
        {children}
      </Box>

      {clickable && chevron && <ChevronRightIcon sx={{ flexShrink: 0, color: MUTED }} />}
    </Box>
  );
};

export const Panel = ({ icon: Icon, title, actions, toolbar, children, sx }) => (
  <Box
    sx={{
      display: "flex",
      flexDirection: "column",
      height: "calc(100vh - 300px)",
      minHeight: 460,
      backgroundColor: SURFACE,
      border: `1px solid ${BORDER}`,
      borderRadius: "10px",
      overflow: "hidden",
      ...sx,
    }}
  >
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        gap: 1,
        px: 2,
        py: 1.25,
        backgroundColor: SURFACE_HEAD,
        borderBottom: "1px solid #1e1e1e",
      }}
    >
      <Box sx={{ display: "flex", alignItems: "center", gap: 1, minWidth: 0 }}>
        {Icon && <Icon sx={{ fontSize: 18, color: palette.primary.light }} />}
        <Typography sx={{ fontWeight: 700, fontSize: 14 }} noWrap>{title}</Typography>
      </Box>
      {actions && <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>{actions}</Box>}
    </Box>

    {toolbar && (
      <Box sx={{ px: 2, py: 1.25, borderBottom: `1px solid ${BORDER}` }}>{toolbar}</Box>
    )}

    <Box sx={{ flex: 1, minHeight: 0, display: "flex", flexDirection: "column" }}>{children}</Box>
  </Box>
);
